import { ApiV2Response } from '../../../../types';
import { nzApiClient } from '../../../../utils';
import { PrivateAccountRepository, PrivateNizzaAccount } from '../../domain';
import { RawPrivateAccount } from '../dtos';
import { rawPrivateAccountToDomain } from '../mappers';

export class RestPrivateAccountRepository implements PrivateAccountRepository {
  async get(account: string): Promise<PrivateNizzaAccount | null> {
    const { data } = await nzApiClient.rest<ApiV2Response<RawPrivateAccount>>({
      path: `/v1/accounts/${account}`,
      secure: true,
      account,
    });

    return data ? rawPrivateAccountToDomain(data) : null;
  }
}
